module.exports = __webpack_public_path__ + "img/TeamComic_005.a90a317b.png";